import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { KpiDefinition } from '../../interfaces/kpi-definition';
import {DisplayServiceProvider} from "../../../core/services/display-service/display-service";
import {KpiConfig, KpiDto} from "./kpi.interface";

/*
  Generated class for the KpiServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class KpiServiceProvider implements OnInit {
  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider, private displayService: DisplayServiceProvider) {}

  ngOnInit() {}

  load() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('kpiDefinitions'))
        .toPromise()
        .then((response) => {
          this.storageService.setObject('kpiDefinitions', response);
          resolve(response);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  }

  getKpisOfCurrentUser(): Promise<KpiDto[]> {
    return new Promise((resolve, reject) => {
      let kpiConfig: KpiConfig;
      kpiConfig = this.displayService.getScreenComponent('dummy', 'motivizer');
      this.http
        .get(this.configService.getUrl('kpisOfCurrentUser') + "?kpiIds=" + this.getKpiIdsAsString(kpiConfig))
        .toPromise()
        .then((response: KpiDto[]) => {
          resolve(response);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    })
  }

  getKpiDefinitions(): Promise<KpiDefinition[]> {
    return this.storageService.getObject('kpiDefinitions');
  }

  private getKpiIdsAsString(kpiConfig: KpiConfig): string {
    const kpiIds = []
    if(kpiConfig.kpiId) {
      kpiIds.push(kpiConfig.kpiId)
    }
    if(kpiConfig.kpiIds){
      kpiConfig.kpiIds.forEach(kpiId => kpiIds.push(kpiId))
    }

    return kpiIds.map(kpiId => String(kpiId)).join(",")
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/kpi-service/kpi-service.ts